<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="Part1"><a id="page_9"></a><strong><span class="small">PART ONE</span></strong></h2>
<h2 class="h2a"><span class="small"><strong>MAKING A SETTLEMENT</strong></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?0dd42a58